// PDP Image Click PDP-05,PDP-06,PDP-07,PDP-08 --start

{
  document.querySelectorAll('.block-swatch__radio').forEach((el) => {
    el.addEventListener('click', (e) => {
      const swatch = el.closest('.block-swatch');
      const swatchPosition = swatch.getAttribute('data-item-index');
      const label = el.closest('.block-swatch')?.querySelector('.block_text');
      const text = label ? label.textContent.trim() : null;
      const discountElement = swatch.querySelector('.discounted-price--wrapper');
      let priceText = null;
      if (discountElement) {
        const priceTextElement = discountElement.querySelector('.block_price_text') || discountElement;
        if (priceTextElement) {
          const nestedPriceBox = priceTextElement.querySelector('.price_box_inner');
          if (nestedPriceBox) {
            const nestedPriceText = nestedPriceBox.querySelector('.block_price_text');
            if (nestedPriceText) {
              priceText = nestedPriceText.textContent.trim();
            }
          } else {
            priceText = priceTextElement.textContent.trim();
          }
        }
      }else{
        priceText = el.closest('.block-swatch')?.querySelector('.price_box_inner').querySelector('.block_price_text')?.textContent.trim() || swatch.querySelector('.js-price')?.textContent.trim();
      }
      if (swatch.classList.contains('is-membership-variant')){
       if (document.querySelector('.js-membership-subscription')) {   
        let valueCheck = document.querySelector('.js-membership-subscription').checked;  
        tagular('ElementClicked', {
          actionOutcome: valueCheck ? "SELECT" : "UNSELECT",     
          outboundUrl: null,
          webElement: {
            elementType: 'Button',
            htmlId: null,
            location: 'PDP - Product Options',
            name: "LP Insider",
            position: "4",
            text: null,
            variant: null
          }
        });
      }
      }else{
        tagular('ElementClicked', {
          actionOutcome: 'SELECT',
          outboundUrl: null,
          webElement: {
            elementType: 'Button',
            htmlId: null,
            location: 'PDP - Product Options',
            name: text,
            position: swatchPosition,
            text: `${text} ${priceText}`,
            variant: null
          }
        });
      }
    });
  });
}


// Complete Your Travels chechbox PDP-13 --start

{
  setTimeout(function () {
    var checkboxes = document.querySelectorAll(".cbb-frequently-bought-selector-input");
  
    checkboxes.forEach(function (checkbox, index) {
      checkbox.addEventListener("change", function () {
        var isChecked = checkbox.checked;
        var swatch = checkbox.closest("li");
        var titleElement = swatch.querySelector("h3") || null;
        var guidebookTitle = titleElement ? titleElement.innerText.trim() : null;
        
        tagular("ElementClicked", {
          actionOutcome: isChecked ? "CHECK" : "UNCHECK",
          outboundUrl: null,
          webElement: {
            elementType: "Checkbox",
            htmlId: null,
            location: "PDP Product Recs",
            name: guidebookTitle,
            position: (index + 1).toString(),
            text: null,
            variant: null
          }
        });
      });
    });
  }, 2500);  
}
// Complete Your Travels chechbox PDP-13 --end

// Complete Your Travels Book Variation dropdown PDP-14 --start

{
  setTimeout(function () {
    const dropdowns = document.querySelectorAll(".cbb-recommendations-variant-select");
  
    dropdowns.forEach((dropdown, index) => {
      dropdown.addEventListener("change", function () {
        const swatch = dropdown.closest("li");
        const titleElement = swatch.querySelector("h3");
        const guidebookTitle = titleElement ? titleElement.innerText.trim() : null;
  
        const selectedOption = dropdown.options[dropdown.selectedIndex];
        const variantText = selectedOption ? selectedOption.textContent.trim() : null;
  
        tagular("ElementClicked", {
          actionOutcome: "SELECT",
          outboundUrl: null,
          webElement: {
            elementType: "Dropdown",
            htmlId: null,
            location: "PDP Product Recs",
            name: `${guidebookTitle} - ${variantText}`,
            position: (index + 1).toString(),
            text: null,
            variant: null
          }
        });
      });
    });
  },2500);
}

// Complete Your Travels Book Variation dropdown PDP-14 --end

// Main Image gallery full screen toggle PDP-04 --start

{
  let imageElement = document.querySelectorAll('.js-zoom-image');
  imageElement.forEach((mainImage)=>{
    if (mainImage) {
      mainImage.addEventListener("click", function () {
        tagular("ElementClicked", {
          actionOutcome: "POPUP",
          outboundUrl: null,
          webElement: {
            elementType: "Image",
            htmlId: null,
            location: "PDP - Image Gallery",
            name: "Main Gallery",
            position: null,
            text: null,
            variant: null,
          }
        });
      });
    }
  });
}
// Main Image gallery full screen toggle PDP-04 --end


{
  let membershipSwatchMain = document.querySelector('.membership_swatch_main summary');
  if (membershipSwatchMain) {
    membershipSwatchMain.addEventListener("click", function () {
        let detailsEl = membershipSwatchMain.closest("details");
        let isOpen = detailsEl && detailsEl.hasAttribute('open'); // Use attribute instead of class
        let actionOutcome = isOpen ? "COLLAPSE" : "EXPAND";
        tagular("ElementClicked", {
          actionOutcome: actionOutcome,
          outboundUrl: null,
          webElement: {
            elementType: "Button",
            htmlId: null,
            location: "PDP - Product Options",
            name: "LP Insider",
            position: "4",
            text: null,
            variant: null
          }
        });
    });
  }
}


    
  
